import * as m4 from "./m4"

function create_shader(gl, type, source) {
    let shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);

    let success = gl.getShaderParameter(shader, gl.COMPILE_STATUS);

    if (success) {
        return shader;
    }

    console.log(gl.getShaderInfoLog(shader));
    gl.deleteShader(shader);
}

function create_program(gl, vertex_shader, fragment_shader) {
    let program = gl.createProgram();
    gl.attachShader(program, vertex_shader);
    gl.attachShader(program, fragment_shader);
    gl.linkProgram(program);
    gl.validateProgram(program);

    let success = gl.getProgramParameter(program, gl.LINK_STATUS);

    if (success) {
        return program;
    }

    console.log(gl.getProgramInfoLog(program));
    gl.deleteProgram(program);
}

function update(state) {
    let width = state.canvas.clientWidth;
    let height = state.canvas.clientHeight;

    if (state.canvas.width !== width || state.canvas.height !== height) {
        state.canvas.width = width;
        state.canvas.height = height;
    }

    state.ctx.viewport(0, 0, state.ctx.drawingBufferWidth, state.ctx.drawingBufferHeight);

    state.ctx.clearColor(1.0, 1.0, 1.0, 1);
    state.ctx.clear(state.ctx.COLOR_BUFFER_BIT);


    state.ctx.useProgram(state.program);
    state.ctx.bindVertexArray(state.vertex_array);

    for (let index = 0; index < state.instance_count; index += 1) {
        let mat = state.matrices[index];
        let col = state.colors[index];
        state.user_update(mat, col, index, width, height, state.instance_count);
    }

    state.ctx.bindBuffer(state.ctx.ARRAY_BUFFER, state.matrix_buffer);
    state.ctx.bufferSubData(state.ctx.ARRAY_BUFFER, 0, state.matrix_data);

    state.ctx.bindBuffer(state.ctx.ARRAY_BUFFER, state.color_buffer);
    state.ctx.bufferSubData(state.ctx.ARRAY_BUFFER, 0, state.color_data);

    state.ctx.uniformMatrix4fv(state.uniforms.projection.location, false, m4.ortho(0, state.canvas.width, state.canvas.height, 0, 1.0, -1.0));
    state.ctx.uniformMatrix4fv(state.uniforms.view.location, false, m4.identity());
    state.ctx.uniform1f(state.uniforms.time.location, performance.now());
    state.ctx.uniform1i(state.uniforms.debug.location, state.debug ? 1 : 0);

    state.ctx.drawElementsInstanced(
        state.ctx.TRIANGLES,
        state.number_of_elements,
        state.ctx.UNSIGNED_SHORT,
        0,
        state.instance_count
    );

    requestAnimationFrame(update.bind(this, state));
}


function init(selector_or_element, options) {
    if (typeof selector_or_element == "string") {
        var elements = document.querySelectorAll(selector_or_element);
        for (var i = 0; i < elements.length; i += 1) {
            blobs_init(elements[i], options);
        }
    } else if (typeof selector_or_element == "object") {
        if (selector_or_element instanceof HTMLElement &&  selector_or_element.tagName == "CANVAS") {
            blobs_init(element, options);
        }
    }
}

function blobs_init(element, options) {
    let state = {
        canvas: null,
        ctx: null,
        debug: false,

        // @NOTE(Grey): These are my draw state things that should be bundled
        program: null,
        vertex_array: null,
        number_of_elements: null,

        matrix_buffer: null,
        matrix_data: null,
        matrices: null,

        color_buffer: null,
        color_data: null,
        colors: null,

        uniforms: {
            // uniform_name: { location: , setter: func(v) {}, }
        },

        instance_max: 256,
        instance_count: 6,

        user_update: function(mat, index, width, height, count) {},
    };

    function cleanup_if_unable_to_boot_webgl(state_ctx) {
        state_ctx.canvas.style.opacity = 0.0;
    }


    state.canvas = element;
    if (state.canvas) {
        state.ctx = state.canvas.getContext("webgl2", { alpha: false });
    } else {
        return;
    }

    if (!state.ctx) {
        cleanup_if_unable_to_boot_webgl(state);
        return;
    }

    // @NOTE(Grey): Apply all the options
    state = Object.assign(state, options);

    state.ctx.enable(state.ctx.BLEND);
    state.ctx.blendFunc(state.ctx.SRC_ALPHA, state.ctx.ONE_MINUS_SRC_ALPHA);

    let vertex_shader_source = `#version 300 es
        in vec4 a_position;
        in vec2 a_uv;
        in mat4 a_matrix;
        in vec4 a_color;

        uniform mat4 u_projection;
        uniform mat4 u_view;
        uniform float u_time;

        out vec4 v_color;
        out vec2 v_pos;
        out vec2 v_uv;

        void main() {
            v_color = a_color;
            v_uv = a_uv;
            v_pos = (u_projection * u_view * a_matrix * a_position).xy;

            gl_Position = u_projection * u_view * a_matrix * a_position;
        }
    `;
    let fragment_shader_source = `#version 300 es
        #ifdef GL_FRAGMENT_PRECISION_HIGH
           precision highp float;
        #else
           precision mediump float;
        #endif

        in vec4 v_color;
        in vec2 v_pos;
        in vec2 v_uv;

        uniform float u_time;
        uniform int u_debug;

        out vec4 frag_color;

        #define PI radians(180.0)

        float ndot(vec2 a, vec2 b ) { return a.x*b.x - a.y*b.y; }

        // 2D Random
        float random (in vec2 st) {
            return fract(sin(dot(st.xy,
                                 vec2(12.9898,78.233)))
                         * 43758.5453123);
        }

        // 2D Noise based on Morgan McGuire @morgan3d
        // https://www.shadertoy.com/view/4dS3Wd
        float noise (in vec2 st) {
            vec2 i = floor(st);
            vec2 f = fract(st);

            // Four corners in 2D of a tile
            float a = random(i);
            float b = random(i + vec2(1.0, 0.0));
            float c = random(i + vec2(0.0, 1.0));
            float d = random(i + vec2(1.0, 1.0));

            // Smooth Interpolation
            // Cubic Hermine Curve.  Same as SmoothStep()
            vec2 u = f*f*(3.0-2.0*f);

            // Mix 4 coorners percentages
            return mix(a, b, u.x) +
                    (c - a)* u.y * (1.0 - u.x) +
                    (d - b) * u.x * u.y;
        }

        float sdCircle( in vec2 p, in float r )
        {
            return length(p)-r;
        }

        float sdBox( in vec2 p, in vec2 b )
        {
            vec2 d = abs(p)-b;
            return length(max(d,0.0)) + min(max(d.x,d.y),0.0);
        }

        float sdOrientedBox( in vec2 p, in vec2 a, in vec2 b, float th )
        {
            float l = length(b-a);
            vec2  d = (b-a)/l;
            vec2  q = p-(a+b)*0.5;
                  q = mat2(d.x,-d.y,d.y,d.x)*q;
                  q = abs(q)-vec2(l*0.5,th);
            return length(max(q,0.0)) + min(max(q.x,q.y),0.0);
        }

        float sdRhombus( in vec2 p, in vec2 b )
        {
            p = abs(p);

            float h = clamp( ndot(b-2.0*p,b)/dot(b,b), -1.0, 1.0 );
            float d = length( p-0.5*b*vec2(1.0-h,1.0+h) );

            return d * sign( p.x*b.y + p.y*b.x - b.x*b.y );
        }

        float sdEquilateralTriangle( in vec2 p, in float r )
        {
            const float k = sqrt(3.0);
            p.x = abs(p.x) - r;
            p.y = p.y + r/k;
            if( p.x+k*p.y>0.0 ) p = vec2(p.x-k*p.y,-k*p.x-p.y)/2.0;
            p.x -= clamp( p.x, -2.0*r, 0.0 );
            return -length(p)*sign(p.y);
        }

        float merge(in float a, in float b)
        {
            return min(a, b);
        }

        float intersect(in float a, in float b)
        {
            return max(a, b);
        }

        float subtract(in float a, in float b)
        {
            return intersect(a, -b);
        }

        // @NOTE(Grey): This is a specific shaping function
        // for the gradient falloff
        float roof(in float x)
        {
            return pow(min(cos(PI * x / 2.0), 1.0 - abs(x)), 1.5);
        }


        void main() {
            float t = u_time *0.00025;

            vec3 col = vec3(1.0);
            float rad = (1.0 + noise(v_uv + v_pos + t) / 2.0) * 0.25;
            float d = sdCircle(v_uv - 0.5, rad);

            if (u_debug > 0)
            {
                frag_color = vec4(v_color.rgb, d < 0.0 ? 1.0 - d : 0.0);
            }
            else
            {
                frag_color = vec4(v_color.rgb, d < 0.0 ? 1.0 - roof(d) : 0.0);
            }
        }
    `;

    let vertex_shader   = create_shader(state.ctx, state.ctx.VERTEX_SHADER, vertex_shader_source);
    let fragment_shader = create_shader(state.ctx, state.ctx.FRAGMENT_SHADER, fragment_shader_source);

    if (!vertex_shader || !fragment_shader) {
        cleanup_if_unable_to_boot_webgl(state);
        return;
    }

    state.program = create_program(state.ctx, vertex_shader, fragment_shader);

    if (!state.program) {
        cleanup_if_unable_to_boot_webgl(state);
        return;
    }

    let position_attribute_location = state.ctx.getAttribLocation(state.program, "a_position");
    let uv_attribute_location       = state.ctx.getAttribLocation(state.program, "a_uv");
    let matrix_attribute_location   = state.ctx.getAttribLocation(state.program, "a_matrix");
    let color_attribute_location    = state.ctx.getAttribLocation(state.program, "a_color");

    let projection_uniform_location = state.ctx.getUniformLocation(state.program, "u_projection");
    let view_uniform_location       = state.ctx.getUniformLocation(state.program, "u_view");
    let time_uniform_location       = state.ctx.getUniformLocation(state.program, "u_time");
    let debug_uniform_location      = state.ctx.getUniformLocation(state.program, "u_debug");

    state.uniforms.projection = { location: projection_uniform_location }
    state.uniforms.view       = { location: view_uniform_location }
    state.uniforms.time       = { location: time_uniform_location }
    state.uniforms.debug      = { location: debug_uniform_location }

    state.vertex_array = state.ctx.createVertexArray();
    state.ctx.bindVertexArray(state.vertex_array);

    let position_buffer = state.ctx.createBuffer();
    state.ctx.bindBuffer(state.ctx.ARRAY_BUFFER, position_buffer);

    state.ctx.bufferData(
        state.ctx.ARRAY_BUFFER,
        new Float32Array([
            -1.0, -1.0,
             1.0, -1.0,
            -1.0,  1.0,
             1.0,  1.0,
        ]),
        state.ctx.STATIC_DRAW
    );

    let uv_buffer = state.ctx.createBuffer();
    state.ctx.bindBuffer(state.ctx.ARRAY_BUFFER, uv_buffer);

    state.ctx.bufferData(
        state.ctx.ARRAY_BUFFER,
        new Float32Array([
            0.0, 0.0,
            1.0, 0.0,
            0.0, 1.0,
            1.0, 1.0,
        ]),
        state.ctx.STATIC_DRAW
    );

    let index_buffer = state.ctx.createBuffer();
    state.ctx.bindBuffer(state.ctx.ELEMENT_ARRAY_BUFFER, index_buffer);

    let indices = [
        0, 1, 2,
        1, 3, 2,
    ];
    state.ctx.bufferData(
        state.ctx.ELEMENT_ARRAY_BUFFER,
        new Uint16Array(indices),
        state.ctx.STATIC_DRAW
    );

    state.number_of_elements = 6;

    state.ctx.enableVertexAttribArray(position_attribute_location);
    state.ctx.bindBuffer(state.ctx.ARRAY_BUFFER, position_buffer);
    state.ctx.vertexAttribPointer(position_attribute_location, 2, state.ctx.FLOAT, false, 0, 0);

    state.ctx.enableVertexAttribArray(uv_attribute_location);
    state.ctx.bindBuffer(state.ctx.ARRAY_BUFFER, uv_buffer);
    state.ctx.vertexAttribPointer(uv_attribute_location, 2, state.ctx.FLOAT, false, 0, 0);

    state.ctx.bindBuffer(state.ctx.ELEMENT_ARRAY_BUFFER, index_buffer);


    state.matrix_data = new Float32Array(state.instance_max * 16);
    state.matrices = [];
    for (let i = 0; i < state.instance_max; ++i) {
        let byte_offset_to_matrix = i * 16 * 4;
        let num_floats_for_view = 16;
        state.matrices.push(new Float32Array(
            state.matrix_data.buffer,
            byte_offset_to_matrix,
            num_floats_for_view));
    }

    state.matrix_buffer = state.ctx.createBuffer();
    state.ctx.bindBuffer(state.ctx.ARRAY_BUFFER, state.matrix_buffer);
    state.ctx.bufferData(state.ctx.ARRAY_BUFFER, state.matrix_data.byteLength, state.ctx.DYNAMIC_DRAW);

    let bytes_per_matrix = 4 * 16;
    for (let i = 0; i < 4; ++i) {
        let loc = matrix_attribute_location + i;
        state.ctx.enableVertexAttribArray(loc);

        let offset = i * 16;
        state.ctx.vertexAttribPointer(
            loc,
            4,
            state.ctx.FLOAT,
            false,
            bytes_per_matrix,
            offset
        );
        state.ctx.vertexAttribDivisor(loc, 1);
    }


    state.color_data = new Float32Array(state.instance_max * 4);
    state.colors = [];

    for (let i = 0; i < state.instance_max; ++i) {
        let byte_offset_to_color = i * 4 * 4;
        let num_floats_for_view = 4;
        state.colors.push(new Float32Array(
            state.color_data.buffer,
            byte_offset_to_color,
            num_floats_for_view));
    }

    state.color_buffer = state.ctx.createBuffer();
    state.ctx.bindBuffer(state.ctx.ARRAY_BUFFER, state.color_buffer);
    state.ctx.bufferData(state.ctx.ARRAY_BUFFER, state.color_data.byteLength, state.ctx.DYNAMIC_DRAW);


    state.ctx.enableVertexAttribArray(color_attribute_location);
    state.ctx.vertexAttribPointer(color_attribute_location, 4, state.ctx.FLOAT, false, 0, 0);
    state.ctx.vertexAttribDivisor(color_attribute_location, 1);

    state.ctx.bindVertexArray(null);


    window.addEventListener('keyup', function(event) {
        if (event.key === 'b') {
            state.debug = !state.debug;
        }
    });

    update(state);
}

export {
    init,
}
